import { render, staticRenderFns } from "./new-user-role-form.vue?vue&type=template&id=95add28e&scoped=true"
import script from "./new-user-role-form.vue?vue&type=script&lang=js"
export * from "./new-user-role-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95add28e",
  null
  
)

export default component.exports